import React from "react";
import PageContainer from "../../../../hoc/PageContainer";
import "./PakTinEst.css";

import { Image } from "semantic-ui-react";
import IMG1 from "../../img/2122-service-2/2122-service-2-1-min.jpg";
import IMG2 from "../../img/2122-service-2/2122-service-2-2-min.jpg";
import IMG3 from "../../img/2122-service-2/2122-service-2-3-min.jpg";
import IMG4 from "../../img/2122-service-2/2122-service-2-4-min.jpg";
import IMG5 from "../../img/2122-service-2/2122-service-2-5-min.jpg";
import IMG6 from "../../img/2122-service-2/2122-service-2-6-min.jpg";
import IMG7 from "../../img/2122-service-2/2122-service-2-7-min.jpg";
import IMG8 from "../../img/2122-service-2/2122-service-2-8-min.jpg";

const PakTinEst = () => (
  <PageContainer page="ourServices">
    <h1 className="AboutUsTitle">
      Rotary Club of Central - 白田邨新居入伙禮包派贈日
    </h1>
    <div className="AboutUsText">
      <h2 className="AboutUsTitleNoPadding" id="make-a-wish-2009">
        Date: 18 September 2021
        <br />
        <br />
        Beneficiaries: Around 250 households of elderly living alone
        <br />
        <br />
        No. of participants: Around 150 participants <br />
        <br />
      </h2>
    </div>
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG2} />
    </div>
    <div className="AboutUsText">
      <p>
        Pak Tin Estate is a very long-established public housing estate which
        has recently been rebuilt and redeveloped at the same place. Since we
        know the residents are mainly elderly living alone who may have
        difficulties in moving their homes, we first organized a fund-raising
        event to buy some furnitures, electrical appliances and daily
        necessities for them. We also helped the elderly living alone to move
        all donated items to their new homes. We even helped them install and
        set up all these furnitures and electrical appliances at their new homes
        so that they can easily move in.
      </p>
    </div>
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG1} />
    </div>
    <br />
    <br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG3} />
    </div>
    <br />
    <br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG4} />
    </div>
    <br />
    <br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG5} />
    </div>
    <br />
    <br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG6} />
    </div>
    <br />
    <br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG7} />
    </div>
    <br />
    <br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG8} />
    </div>
    <br />
    <br />
  </PageContainer>
);

export default PakTinEst;
